import pulse from '@finn-no/pulse-sdk';
import './styles.css';

const urlParams = new URLSearchParams(window.location.search);
const finnkode = urlParams?.get('finnkode');

// TJT_ev05
const trackViewButton = () =>
    pulse.trackEvent({
        type: 'View',
        intent: 'Contact',
        name: 'Purchase with delivery',
        object: {
            id: `tjt-create-offer-button-view`,
            type: 'UIElement',
            elementType: 'Button',
        },
        vertical: {
            name: 'bap',
            subVertical: 'transaction_journey_bap',
        },
    });

// TJT_ev01
const trackCreateOfferClick = () =>
    pulse.trackEvent({
        type: 'Click',
        intent: 'Contact',
        name: 'Purchase with delivery',
        object: {
            id: `tjt-create-offer-button`,
            type: 'UIElement',
            elementType: 'Button',
            items: [
                {
                    type: 'ClassifiedAd',
                    id: finnkode,
                    contentId: finnkode,
                    name: 'n/a',
                    category: 'n/a',
                },
            ],
        },
        target: {
            id: finnkode,
            type: 'ProcessFlow',
            name: 'Transactionjourney bap',
        },
        vertical: {
            name: 'bap',
        },
    });

const link = document.getElementById('tjt-create-offer-button');

if (link) {
    trackViewButton();
    link.addEventListener('click', trackCreateOfferClick);
}
